import React from 'react'

const Credits = () => {
    return (
        <div className='inner-container' style={{ marginBottom: '50px', paddingBottom: '25px' }}>
            <div className="description">
                site web <a href="https://ff87c3.eu" target="_blank" rel="noopener">ff87c3.eu</a>
            </div>

            <div className="ml-embedded" data-form="4nAjLY"></div>

        </div>
    )
}

export default Credits